import {useRef, useState} from 'react';
import enumList from 'web/utils/enumList';
import {useNavigate} from 'react-router-dom';
import {
  DataTableComponent,
  batchCheckControls,
} from '../../../components/CommonComponent';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
  FLG_SEND,
} from 'web/constant';
import $ from 'jquery';
import {useDispatch} from 'react-redux';
import {fetchDispatchList as getDispatchList} from 'web/redux/actions/DispatchActions';
import {fetchSatisfactionList} from 'web/redux/actions/SatisfactionAction';
import moment from 'moment';

export const useSatisfactionManagementPage = (showMessage, baseComponent) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [surveyList, setSurveyList] = useState([]);
  const [searchCasePriority, setSearchCasePriority] = useState('0');
  const [searchFlgStatus, setSearchFlgStatus] = useState('0');
  const [searchStartDate, setSearchStartDate] = useState(
    moment().format('YYYY-MM-DD'),
  );
  const [searchEndDate, setSearchEndDate] = useState(
    moment().format('YYYY-MM-DD'),
  );
  const tableRef = useRef(null);
  const getSurveyList = (casePriority, surveyStatus, startTime, endTime) => {
    if (!tableRef.current) prepareCaseTable([]);
    tableRef.current.processing(true);
    startTime = moment(startTime).startOf('day').format('YYYYMMDDHHmmss') || ''; // 👉 20250417 00:00:00
    endTime = moment(endTime).endOf('day').format('YYYYMMDDHHmmss') || ''; // 👉 20250417 23:59:59
    dispatch(
      fetchSatisfactionList({
        casePriority,
        surveyStatus,
        startTime,
        endTime,
      }),
    )
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode()) {
          const surveyListRes = res.payload.result;
          // surveyListRes = surveyListRes.filter(({employee}) => employee);
          setSurveyList(surveyListRes);
          prepareCaseTable(surveyListRes);
          tableRef.current.processing(false);
        } else {
          showMessage(enumList.messageModalMode.error, res.payload.message);
          console.error('fetchCaseList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchCaseList error', err);
      });
  };

  const onDetailClicked = (caseID) => {
    navigate(`/module/satisfaction-management/${caseID}`);
  };

  const prepareCaseTable = (surveyList) => {
    // 定義資料內容
    const dataSet = surveyList.map((surveyItem) => {
      return [
        surveyItem.casePriority,
        surveyItem.caseNumber,
        surveyItem.caseCreateTime,
        surveyItem.customerName,
        surveyItem.description,
        surveyItem.flgStatus,
        surveyItem.caseNumber,
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        title: '案件等級',
        className: 'dt-center',
        data: 0,
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const casePriority =
            data === enumList.casePriority.high
              ? CASE_PRIORITY_HIGH
              : CASE_PRIORITY_NORMAL;
          const labelStyle =
            data === enumList.casePriority.high ? 'status-rush' : '';
          return ` <div class="status ${labelStyle} "> <span>${casePriority}</span> </div>`;
        },
      },
      {title: '案件編號', className: 'dt-center', data: 1},
      {
        title: '立案時間',
        className: 'dt-head-center',
        data: 2,
        render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'),
        type: 'datetime',
      },
      {title: '客戶名稱', className: 'dt-center', data: 3},
      {title: '案件內容', className: 'dt-center text-truncate', data: 4},

      {
        title: '滿意度回饋',
        className: 'dt-center',
        data: 5,
        render: (data, type, row, meta) => {
          const statusMap = new Map([
            [enumList.satisfactionFlgStatus.close, FLG_CLOSE],
            [enumList.satisfactionFlgStatus.send, FLG_SEND],
            [enumList.satisfactionFlgStatus.open, FLG_OPEN],
          ]);

          const satisfactionStatus = statusMap.get(data);
          const labelStyle =
            data === enumList.satisfactionFlgStatus.close
              ? 'status-normal'
              : 'status-danger';
          return ` <div class="status ${labelStyle} mb-2"> <span>${satisfactionStatus}</span> </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        title: '人工抽樣調查',
        className: 'dt-center',
        data: 6,
        render: (data, type, row, meta) => {
          /** @type {HTMLButtonElement} */
          let element = document.createDocumentFragment();
          if (
            baseComponent.checkPermission(
              enumList.moduleEnums.case,
              enumList.accessModeEnums.update,
            )
          ) {
            element = document.createElement('button');
            element.type = 'button';
            element.classList.add('btn', 'btn-sm', 'btn-outline-secondary');
            element.addEventListener('click', () => {
              onDetailClicked(data);
            });
            element.innerText = '查閱內容';
          }
          /** @type {HTMLDivElement} */
          const outerDiv = document.createElement('div');
          outerDiv.setAttribute('role', 'group');
          outerDiv.classList.add('btn-group');
          outerDiv.append(element);
          return outerDiv;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };

    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__satisfactionManagement')) {
      $('#datatable__satisfactionManagement').DataTable().destroy();
    }

    // 重新繪製datatable
    tableRef.current = DataTableComponent(
      '#datatable__satisfactionManagement',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true,
    );
    setSurveyList(surveyList);
    batchCheckControls();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const searchForm = new FormData(e.target);
    const casePriority = searchForm.get('searchCasePriority');
    const caseDispatchEmployee = searchForm.get('searchDispatchEmployee');
    const startTime = searchForm.get('searchStartDate');
    const endTime = searchForm.get('searchEndDate');
    getDispatchList(casePriority, caseDispatchEmployee, startTime, endTime);
  };

  return {
    surveyList,
    getSurveyList,
    handleSearch,
    searchCasePriority,
    setSearchCasePriority,
    searchFlgStatus,
    setSearchFlgStatus,
    searchStartDate,
    setSearchStartDate,
    searchEndDate,
    setSearchEndDate,
  };
};
